import React from "react";
import { useRouteError } from "react-router";

export default function ErrorElement() {
  const error = useRouteError() as any;
  return (
    <div style={{ color: "red", padding: 20 }}>
      <h2>Something went wrong.</h2>
      <pre>
        {(error?.statusText || error?.message) ?? "Unkown error occurred"}
      </pre>
    </div>
  );
}
